import T from "prop-types";
import styled, { ThemeProvider } from "styled-components";
import { Link } from "react-router-dom";
import {
  theme as oldTheme,
  Container,
  P,
  H1,
  ButtonGroup,
  media,
} from "@nested/nested-react-components";

import { Table } from "../../components/Table/Table";
import { CurrentSelectionButton } from "./CurrentSelectionButton";

const TextCenteredContainer = styled(Container)`
  text-align: center;
  padding-top: calc(${({ theme }) => theme.padding.base} * 12);
  overflow: hidden;
`;

const WideP = styled(P)`
  max-width: 900px;
  text-align: left;
  margin: ${({ theme }) => theme.padding.base} 0;
  font-size: 14px !important;
`;

const ScrollContainer = styled(Container)`
  overflow: auto;
  ${media.md`
    align-items: center !important;
  `};
`;

function ResearchStory({ category, columns, content, country, data, story }) {
  return (
    <ThemeProvider theme={oldTheme}>
      <TextCenteredContainer section fixed marginTop={10} align="center">
        <H1>{content.title}</H1>
        <ButtonGroup marginTop={2} align="center">
          {content.topButtons.map(
            ({ text, country: countryLabel, countryUrl }) => (
              <CurrentSelectionButton
                secondary={country !== countryLabel}
                to={`/research/${story}/2017/${countryUrl}`}
                as={Link}
                key={text}
              >
                {text}
              </CurrentSelectionButton>
            ),
          )}
        </ButtonGroup>
        {content.intros.map(({ id, text }, index) => (
          <P marginTop={index === 0 ? 5 : 3} key={id}>
            {text}
          </P>
        ))}
        <ButtonGroup marginTop={2} marginBottom={2} align="center">
          {content.buttons.map(({ text, categoryUrl }) => (
            <CurrentSelectionButton
              secondary={`/${category}` !== categoryUrl}
              to={`/research/${story}/2017/${country}${categoryUrl}`}
              as={Link}
              key={text}
            >
              {text}
            </CurrentSelectionButton>
          ))}
        </ButtonGroup>
        <ScrollContainer justify="flex-start">
          <Table
            columns={columns}
            data={data}
            selectedColumn={(columns[columns.length - 1] || {}).accessor}
          />
        </ScrollContainer>
        {content.footnotes.map(({ id, text }) => (
          <WideP key={id}>{text}</WideP>
        ))}
      </TextCenteredContainer>
    </ThemeProvider>
  );
}

ResearchStory.propTypes = {
  columns: T.array,
  data: T.array,
  story: T.string,
  country: T.string,
  category: T.string,
  content: T.shape({
    topButtons: T.array,
    buttons: T.array,
    footnotes: T.array,
    title: T.string,
    intros: T.array,
  }),
};

export { ResearchStory };
